import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { from, of } from "rxjs";
import {
  catchError,
  map,
  mergeMap,
  switchMap,
  take,
  withLatestFrom,
} from "rxjs/operators";
import { LoadingService } from "../../loading/loading.service";
import { MatDialog } from "@angular/material/dialog";
import { AppState, appStore } from "../../app.state";
import { IBusquedaRequest } from "../../interfaces/busqueda";
import { BusquedaService } from "../../services/busqueda/busqueda.service";
import { selectTemasUsuario } from "../usuario/selector";
import {
  buscarEntrada,
  buscarEntradaFail,
  buscarEntradaSuccess,
  entradasLoaded,
  exportEntradas,
  exportEntradasFail,
  exportEntradasSuccess,
  loadingAllEntradasForExportExcel,
  loadingAllEntradasForExportExcelSuccess,
  loadingEntradas,
  loadingEntradasFail,
  loadingEntradasSuccess,
  resetBusqueda,
} from "./actions";
import { selectBusqueda, selectBusquedaEntradas } from "./selector";
import { ExcelFilesService } from "../../services/excel-files/excel-files.service";
import { ConfirmDialogComponent } from "../../confirm-dialog/confirm-dialog.component";
appStore;
@Injectable()
export class BusquedaEffects {
  constructor(
    private actions$: Actions,
    private busquedaService: BusquedaService,
    private excelFilesService: ExcelFilesService,
    private store: Store<AppState>,
    private loadingService: LoadingService,
    public dialog: MatDialog
  ) {}

  buscarEntrada$ = createEffect(() =>
    this.actions$.pipe(
      ofType(buscarEntrada),
      withLatestFrom(this.store.select(selectTemasUsuario)),
      mergeMap(([{ busqueda, tipoBusqueda, request }, user]) => {
        this.loadingService.show();

        this.store.dispatch(resetBusqueda());

        console.log("tipoBusqueda", tipoBusqueda);

        if (busqueda && tipoBusqueda === "busquedaSencilla") {
          const payload: IBusquedaRequest = {
            buscar: busqueda,
            idsTemas: Object.keys(user),
          };
          return this.busquedaService.busqueda(payload).pipe(
            map((res) => {
              this.dialog.closeAll();
              const { entradas, ids } = res;
              if (ids.length === 0) {
                this.showDialog(
                  "Advertencia",
                  "No hay coincidencias con la búsqueda."
                );
                return buscarEntradaFail();
              } else {
                this.loadingService.hide();

                this.store.dispatch(
                  buscarEntradaSuccess({
                    ids: Object.values(ids),
                    busqueda,
                    pages: 1,
                    currentPage: 1,
                    tipoBusqueda,
                  })
                );

                return loadingEntradasSuccess({
                  entradas: Object.values(entradas),
                  currentPage: 1,
                });
              }
            }),
            catchError((error) => {
              console.log("error", error);

              this.loadingService.hide();
              return of(buscarEntradaFail());
            })
          );
        } else if (tipoBusqueda === "busquedaAvanzada" && request) {
          return this.busquedaService.busquedaAvanzada(request).pipe(
            map((res) => {
              this.loadingService.hide();
              this.dialog.closeAll();
              const { entradas, ids } = res;
              if (ids.length === 0) {
                this.showDialog(
                  "Advertencia",
                  "No hay coincidencias con la búsqueda."
                );
                return buscarEntradaFail();
              } else {
                this.store.dispatch(
                  buscarEntradaSuccess({
                    ids: Object.values(ids),
                    busqueda,
                    pages: 1,
                    currentPage: 1,
                    tipoBusqueda,
                  })
                );

                return loadingEntradasSuccess({
                  entradas: Object.values(entradas),
                  currentPage: 1,
                });
              }
            }),
            catchError((error) => {
              console.log("error", error);
              this.loadingService.hide();
              return of(buscarEntradaFail());
            })
          );
        } else {
          this.loadingService.hide();
          return of(buscarEntradaFail());
        }
      }),
      catchError((error) => {
        this.loadingService.hide();
        return of(buscarEntradaFail());
      })
    )
  );
  exportEntradas$ = createEffect(() =>
    this.actions$.pipe(
      ofType(exportEntradas),
      withLatestFrom(
        this.store.select(selectBusquedaEntradas),
        this.store.select(selectBusqueda)
      ),
      mergeMap(([accion, entradas, busqueda]) => {
        this.loadingService.show();
        this.dialog.closeAll();
        if (entradas.length > 0) {
          this.excelFilesService.generateExcel(entradas);
          this.loadingService.hide();
          return of(exportEntradasSuccess());
        } else if (entradas.length == 0) {
          this.showDialog("Advertencia", "No hay coincidencias para exportar.");
          this.loadingService.hide();
          return of(exportEntradasFail());
        } else {
          this.loadingService.hide();
          return of(exportEntradasFail());
        }
      }),
      catchError((error) => {
        this.loadingService.hide();
        return of(exportEntradasFail());
      })
    )
  );

  // loadingEntradas$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(loadingEntradas),
  //     withLatestFrom(this.store.select(selectBusqueda)),
  //     switchMap(
  //       ([
  //         accion,
  //         { entradas, busqueda, ids, pages, currentPage, tipoBusqueda },
  //       ]) => {
  //         this.loadingService.show();
  //         if (currentPage < pages) {
  //           const paginaInicio = currentPage * 100;
  //           const paginaFin = (currentPage + 1) * 100;
  //           const currentIds = ids.slice(paginaInicio, paginaFin);
  //           return from(this.busquedaService.buscarAPI([], "", busqueda)).pipe(
  //             take(1),
  //             map((data) => {
  //               this.loadingService.hide();
  //               return loadingEntradasSuccess({
  //                 entradas: Object.values(data.entradas),
  //                 currentPage: currentPage + 1,
  //               });
  //             }),
  //             catchError((error) => {
  //               this.loadingService.hide();
  //               console.error("Error loading entries:", error);
  //               return of(buscarEntradaFail());
  //             })
  //           );
  //         } else if (pages === currentPage) {
  //           this.loadingService.hide();
  //           return of(entradasLoaded());
  //         } else {
  //           this.loadingService.hide();
  //           return of(loadingEntradasFail());
  //         }
  //       }
  //     ),
  //     catchError((error) => {
  //       this.loadingService.hide();
  //       return of(loadingEntradasFail());
  //     })
  //   )
  // );
  loadingAllEntradasForExportExcel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadingAllEntradasForExportExcel),
      withLatestFrom(this.store.select(selectBusqueda)),
      switchMap(
        ([
          accion,
          { entradas, busqueda, ids, pages, currentPage, tipoBusqueda },
        ]) => {
          this.loadingService.show();
          if (currentPage < pages) {
            const paginaInicio = currentPage * 100;
            const currentIds = ids.slice(paginaInicio, ids.length);
            return from(this.busquedaService.buscarAPI([], "", busqueda)).pipe(
              take(1),
              map((data) => {
                this.loadingService.hide();
                this.store.dispatch(
                  loadingEntradasSuccess({
                    entradas: Object.values(data.entradas),
                    currentPage: pages,
                  })
                );
                return loadingAllEntradasForExportExcelSuccess();
              }),
              catchError((error) => {
                this.loadingService.hide();
                console.error("Error loading entries:", error);
                return of(buscarEntradaFail());
              })
            );
          } else if (pages === currentPage) {
            this.loadingService.hide();
            return of(entradasLoaded());
          } else {
            this.loadingService.hide();
            return of(loadingEntradasFail());
          }
        }
      ),
      catchError((error) => {
        this.loadingService.hide();
        return of(loadingEntradasFail());
      })
    )
  );

  loadingAllEntradasForExportExcelSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadingAllEntradasForExportExcelSuccess),
      switchMap(() => {
        return of(exportEntradas());
      })
    )
  );

  private showDialog(title: string, message: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title,
        message,
        showButtons: {
          accept: true,
          cancel: false,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "CERRAR" },
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {});
  }
}
